import React, { useEffect, useState } from 'react';

import { PopUp, Dialog, DialogHeader, DialogContent } from '@ergeon/core-components';

import { type ModalHandler } from '../index';
import { logService } from '../../services';
import LogsDisplay from '../../components/LogsDisplay';
import { useModalClose } from '../../hooks/useModalClose';

type Props = {modal: ModalHandler};

const LogsModal: React.FC<Props> = ({ modal }) => {
  const [logs, setLogs] = useState<string[]>([]);
  const closeModal = useModalClose(modal);

  useEffect(() => {
    setLogs([...logService.logs]);

    const onLog = () => {
      setLogs([...logService.logs]);
    };

    logService.on('log', onLog);

    return () => {
      logService.off('log', onLog);
    };
  }, []);

  return (
    <PopUp isVisible={modal.visible} maxWidth="large" onChangeVisible={closeModal}>
      <Dialog isVisible={modal.visible}>
        <DialogHeader onDismiss={closeModal} title="System Logs" />
        <DialogContent>
          <LogsDisplay logs={logs} />
        </DialogContent>
      </Dialog>
    </PopUp>
  );
};

export default LogsModal;
